// extracted by mini-css-extract-plugin
module.exports = {"reviewCard":"communityReviewItem__reviewCard--1RupJ","reviewSection":"communityReviewItem__reviewSection--1OjzI"};